<div
  class="tournament-countdown"
  [ngClass]="{
    'tournament-countdown__coming-soon': isComingSoon,
    'tournament-countdown__ended': isEnded
  }"
  *ngIf="startDate && endDate"
>
  <span class="tournament-countdown__text" *ngIf="isComingSoon"
    >Coming soon:</span
  >
  <span class="tournament-countdown__text" *ngIf="isEnded"
    >Tournament ended</span
  >
  <span class="tournament-countdown__text" *ngIf="!isComingSoon && !isEnded"
    >Time remain:</span
  >
  <span class="tournament-countdown__timer" *ngIf="!isEnded">
    <fz-countdown
      [leftTime]="
        isComingSoon && startDate
          ? startDate
          : !isEnded && endDate
            ? endDate
            : null
      "
      (handleEvent)="onEvent($event)"
    ></fz-countdown>
  </span>
</div>
